<template>
  <ForgotPassword/>
</template>

<script>
import ForgotPassword from "@/components/Authentication/ResetPassword/ForgotPassword";

export default {
  name: "ForgotPasswordPage",
  components: {ForgotPassword}
};
</script>

<style scoped>

</style>